import { useEffect } from "react";

const NotificationsOne = ({ show, message, toggleShow, type }) => {
    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                toggleShow(false);
            }, 15000);

            return () => clearTimeout(timer);
        }
    }, [show]);

    if (!show) return null;
    const notificationColor = type === "error" ? "bg-red" : "bg-[#1EA779]";
    const notificationTitle = type === "error" ? "Error" : "Congratulations";

    return (
        show && (
            <div className="mt-5 mb-5">
                <div className="bg-white rounded-lg py-4 pl-4 pr-4.5 shadow-2 dark:bg-meta-4">
                    <div className="flex items-center justify-between">
                        <div className="flex flex-grow items-center gap-5">
                            <div
                                className={`flex h-10 w-full max-w-10 items-center justify-center rounded-full ${notificationColor}`}
                            >
                                {/* Customize the icon for error or success */}
                                {type === "error" ? (
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18ZM10 13C10.553 13 11 13.447 11 14C11 14.553 10.553 15 10 15C9.447 15 9 14.553 9 14C9 13.447 9.447 13 10 13ZM9 5H11V11H9V5Z"
                                            fill="white"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        width="20"
                                        height="16"
                                        viewBox="0 0 20 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        {/* Success icon */}
                                        <path
                                            d="M18.1264 2.27326C17.9391 2.06543 17.6448 2.06543 17.4574 2.27326L7.69058 12.7836C7.61031 12.8726 7.50327 12.8726 7.423 12.7836L2.5797 7.5581C2.39239 7.35027 2.09805 7.35027 1.91074 7.5581C1.72343 7.76593 1.72343 8.09252 1.91074 8.30035L6.75403 13.5258C6.9681 13.7633 7.26245 13.8821 7.53003 13.8821C7.82437 13.8821 8.09196 13.7633 8.30603 13.5258L18.0729 3.01551C18.287 2.80768 18.287 2.48109 18.1264 2.27326Z"
                                            fill="white"
                                        />
                                    </svg>
                                )}
                            </div>
                            <div>
                                <h4 className="mb-0.5 text-title-xsm font-medium text-black dark:text-white">
                                    {notificationTitle}
                                </h4>
                                <p className="text-sm font-medium">{message}</p>
                            </div>
                        </div>

                        <div>
                            <button onClick={() => toggleShow(false)}>
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M0.854423 0.85186C1.2124 0.493879 1.79281 0.493879 2.15079 0.85186L7.0026 5.70368L11.8544 0.85186C12.2124 0.493879 12.7928 0.493879 13.1508 0.85186C13.5088 1.20984 13.5088 1.79024 13.1508 2.14822L8.29897 7.00004L13.1508 11.8519C13.5088 12.2098 13.5088 12.7902 13.1508 13.1482C12.7928 13.5062 12.2124 13.5062 11.8544 13.1482L7.0026 8.2964L2.15079 13.1482C1.79281 13.5062 1.2124 13.5062 0.854423 13.1482C0.496442 12.7902 0.496442 12.2098 0.854423 11.8519L5.70624 7.00004L0.854423 2.14822C0.496442 1.79024 0.496442 1.20984 0.854423 0.85186Z"
                                        fill="#B1B1B1"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default NotificationsOne;
